module.exports = __webpack_public_path__ + "static/media/cityBike.15ef5f0b.png";